/**
 * Comparacao de texto para busca de lista.
 *
 * Sem acento e sem caixa, porque quem digita "joao" as 6h da manha no
 * escritorio da obra esta procurando o Joao. Exigir o acento certo para achar
 * uma linha e um filtro que so funciona para quem ja sabe onde a linha esta.
 *
 * Mora em `lib/` e nao dentro de um modulo porque agora sao dois os modulos que
 * buscam por texto — equipamentos e combustivel. Uma copia em cada um seria
 * duas regras de normalizacao que envelhecem separadas, e a primeira divergencia
 * aparece como "achei no filtro de equipamentos e nao achei no de lancamentos".
 */
/**
 * A inicial maiuscula que a TELA poe, e nao o servidor.
 *
 * O backend escreve o campo `erro` em minuscula de proposito: ele e a metade
 * de uma frase que a tela compoe ("Já existe um cliente com esse nome." num
 * alerta, mas "não foi possível gravar: já existe…" no meio de outra). Quem
 * exibe decide a caixa.
 *
 * Mora aqui porque sao TRES as telas que precisam dela — login, lancamento de
 * abastecimento e a recusa do modulo 02 —, e a terceira nao a tinha: as
 * mensagens do modulo de equipamentos chegavam em minuscula enquanto as dos
 * modulos 01 e 08 chegavam capitalizadas, na mesma aplicacao.
 */
export function primeiraMaiuscula(texto: string): string {
  return texto.charAt(0).toLocaleUpperCase('pt-BR') + texto.slice(1);
}

/**
 * `undefined` conta como campo vazio, e nao como erro.
 *
 * O tipo diz `string | null`, mas a lista que chega aqui e montada a partir de
 * um objeto, e campo NOVO no objeto e `undefined` em todo lugar que ainda nao
 * o preenche — uma ficha de teste parcial, um retorno de versao anterior da
 * API guardado no cache do navegador. Antes disto o `normalize` levantava, e o
 * que quebrava nao era a busca: era a LISTA INTEIRA, que nao renderizava. Uma
 * busca que nao acha e um resultado; uma busca que derruba a tela nao e.
 */
export function combinaComTermo(
  campos: readonly (string | null | undefined)[],
  termo: string,
): boolean {
  const procurado = normalizar(termo);
  if (!procurado) return true;
  return campos.some((campo) => typeof campo === 'string' && normalizar(campo).includes(procurado));
}

function normalizar(texto: string): string {
  return texto
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

/**
 * O termo de busca que mora na URL, COMO FOI DIGITADO.
 *
 * O campo de busca das listas é controlado pela URL: cada tecla grava o
 * `?termo=` e o valor do campo volta dele. Aparar o termo ali apagava o espaço
 * no instante em que era digitado — "OPERADOR TESTE ROBÔ" virava
 * "OPERADORTESTEROBÔ" (robôs no QAS, 20/10/2026). Quem apara é quem compara
 * (`combinaComTermo`); a URL guarda o texto inteiro, e só o termo em branco sai.
 */
export function termoDaBusca(valor: unknown): string | undefined {
  return typeof valor === 'string' && valor.trim() !== '' ? valor : undefined;
}
